module.exports = __webpack_public_path__ + "20a810e9b10c871c002d5f93bd479ba2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/diamond-photo/img/large_180x180_noicon.png
// module id = 301
// module chunks = 0